module.exports = __webpack_public_path__ + "img/ref3.4177373f.png";